import React from 'react';
import { StickyTopBar } from './components/StickyTopBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSteps } from './components/SolutionSteps';
import { BenefitCards } from './components/BenefitCards';
import { Testimonials } from './components/Testimonials';
import { CitiesGrid } from './components/CitiesGrid';
import { ContactCTA } from './components/ContactCTA';
import { StickyBottomBar } from './components/StickyBottomBar';
import { FloatingCallButton } from './components/FloatingCallButton';
export function App() {
  return <div dir="rtl" className="min-h-screen bg-white font-sans text-right relative pb-20 md:pb-0" data-id="element-0">
      <StickyTopBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSteps data-id="element-5" />
        <BenefitCards data-id="element-6" />
        <Testimonials data-id="element-7" />
        <CitiesGrid data-id="element-8" />
        <ContactCTA data-id="element-9" />
      </main>

      <footer className="bg-[#050b14] text-gray-500 py-8 text-center text-sm border-t border-gray-800" data-id="element-10">
        <p data-id="element-11">© {new Date().getFullYear()} יבש-טק פרו. כל הזכויות שמורות.</p>
        <p className="mt-2" data-id="element-12">מומחים לייבוש תת רצפתי ואיתור נזילות.</p>
      </footer>

      <StickyBottomBar data-id="element-13" />
      <FloatingCallButton data-id="element-14" />
    </div>;
}